import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { saveToLocalStorage } from '../../../components/helper/authorizationHelper';
import { postAsync } from '../../../components/helper/axiosHelper';
import { menucontrol } from '../../../features/togglebuttonSlice';
import { PageHitCountApi } from '../../../shared/Helper';

export default function OtpPage() {
  const location = useLocation();
  const { loginData } = location.state || {};
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();
  const [isload, setIsload] = useState(false);
  const dispatch = useDispatch();
  const initialMinutes = 10;
  const initialSeconds = 0;
  const tokenStorage = localStorage.getItem('otpToken');
  const otpInputRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  useEffect(() => {
    localStorage.setItem('isHome', true);
    if (!tokenStorage || tokenStorage == undefined || tokenStorage == 'null' || tokenStorage == null) {
      history.back();
    }
    if (otpInputRef.current) {
      otpInputRef.current.focus();
    }
  }, []);

  // Function to calculate remaining time
  const calculateRemainingTime = () => {
    const endTime = JSON.parse(localStorage.getItem('endTime'));
    const timerExpired = localStorage.getItem('timerExpired');
    if (timerExpired) {
      return { minutes: 0, seconds: 0 };
    }

    if (endTime) {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance > 0) {
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        return { minutes, seconds };
      } else {
        // Timer has expired
        localStorage.removeItem('endTime');
        localStorage.setItem('timerExpired', 'true');
        return { minutes: 0, seconds: 0 };
      }
    }
    return { minutes: initialMinutes, seconds: initialSeconds };
  };

  const [remainingTime, setRemainingTime] = useState(calculateRemainingTime);

  useEffect(() => {
    const initialRemainingTime = calculateRemainingTime();
    setRemainingTime(initialRemainingTime);

    let totalTimeInSeconds = initialRemainingTime.minutes * 60 + initialRemainingTime.seconds;

    const timerId = setInterval(() => {
      if (totalTimeInSeconds > 0) {
        totalTimeInSeconds--;

        const minutes = Math.floor(totalTimeInSeconds / 60);
        const seconds = totalTimeInSeconds % 60;

        const updatedTime = { minutes, seconds };

        // Update the state
        setRemainingTime(updatedTime);

        // Save end time to localStorage
        const endTime = new Date().getTime() + totalTimeInSeconds * 1000;
        localStorage.setItem('endTime', JSON.stringify(endTime));
      } else {
        clearInterval(timerId);
        localStorage.removeItem('endTime');
        localStorage.setItem('timerExpired', 'true');
        setRemainingTime({ minutes: 0, seconds: 0 });
      }
    }, 1000);

    // Save end time to localStorage when timer starts
    if (!localStorage.getItem('endTime') && !localStorage.getItem('timerExpired')) {
      const endTime = new Date().getTime() + totalTimeInSeconds * 1000;
      localStorage.setItem('endTime', JSON.stringify(endTime));
    }

    return () => clearInterval(timerId); // Cleanup the interval on unmount
  }, []);

  // Function to clear timer and localStorage upon successful OTP submission
  const handleOTPSuccess = () => {
    setRemainingTime({ minutes: initialMinutes, seconds: initialSeconds });
    localStorage.removeItem('endTime');
    localStorage.removeItem('timerExpired');
  };

  const Otpbody = {
    otp: otp,
    userName: loginData?.userName,
    isUserName: true,
    mobile: 'string',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsload(true);
    await postAsync(`EP_UserAuthentication/ConfirmOTP`, Otpbody)
      .then((response) => {
        if (response?.statusCode !== 422 && response?.statusCode === 200) {
          setStorage(loginData);
          toast.success(`${t('msg_loginSuccess')}`);
          dispatch(menucontrol(false));
          localStorage.setItem('isHome', false);
          localStorage.removeItem('endTime');
          handleOTPSuccess();
          localStorage.setItem('otpToken', null);
          setTimeout(() => {
            window.location.href = '/user';
          }, 500);

          // navigate('/user')
        } else {
          setIsload(false);
          toast.error(`${t(response.value)}`);
        }
      })
      .catch((err) => {
        setIsload(false);
        toast.error(`${t(err?.response?.data?.value)}`);
      });
  };

  const handleResend = async (e) => {
    e.preventDefault();
    await postAsync(
      `EP_UserAuthentication/LoginOTPgenerator`,
      { userName: loginData?.userName, isUserName: true },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
      .then((res) => {
        if (res.statusCode === 200) {
          toast.success(`${t('OTP Resend Successfully')}`);
          localStorage.removeItem('endTime');
          localStorage.removeItem('timerExpired');
          setRemainingTime({ minutes: initialMinutes, seconds: initialSeconds });

          // Start the timer again
          let totalTimeInSeconds = initialMinutes * 60 + initialSeconds;
          const endTime = new Date().getTime() + totalTimeInSeconds * 1000;
          localStorage.setItem('endTime', JSON.stringify(endTime));
          const timerId = setInterval(() => {
            totalTimeInSeconds--;
            const minutes = Math.floor(totalTimeInSeconds / 60);
            const seconds = totalTimeInSeconds % 60;
            setRemainingTime({ minutes, seconds });
            if (totalTimeInSeconds <= 0) {
              clearInterval(timerId);
              localStorage.removeItem('endTime');
              localStorage.setItem('timerExpired', 'true');
              setRemainingTime({ minutes: 0, seconds: 0 });
            }
          }, 1000);
        } else {
          toast.error(`${t(res.value)}`);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t(err.message)}`);
      });
  };
  useEffect(() => {
    if (otpInputRef.current) {
      otpInputRef.current.focus();
    }
  }, [remainingTime.seconds]);

  return (
    <div
      data-aos="zoom-in"
      data-aos-easing="linear"
      data-aos-duration="1500"
      className="mx-auto pt-28 md:pt-20 pb-5 xl:pt-36 "
    >
      {isload ? (
        <LoadingAnimation
          imageStyling={'sm:pb-0'}
          styling={'flex items-center align-middle justify-center space-x-2'}
        />
      ) : (
        <div className="flex justify-center  items-center">
          <div className="w-auto">
            <form className="bg-green-50 shadow-md rounded-4xl pt-6 pb-8  px-10">
              <div className="mb-4">
                <h2 className="text-xl text-center text-customgreen font-bold mb-2">{t('OTP')}</h2>
              </div>
              <div className="">
                <label className="block text-customgreen text-sm lg:text-lg font-bold mb-2">
                  {t('Enter OTP')}
                  <span className="text-red-500">*</span>
                </label>
              </div>
              <div className="mb-4 flex flex-col justify-center items-center">
                <div className="flex w-full justify-center">
                  <input
                    ref={otpInputRef}
                    disabled={remainingTime.minutes == 0 && remainingTime.seconds == 0}
                    className="rounded-lg py-2 w-full px-3 border  text-customgreen  focus:ring-customgreen  my-2 text-center"
                    type="text"
                    maxLength="4"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    onKeyDown={(e) => {
                      const isValidChar =
                        /^[0-9+]$/.test(e.key) || e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Enter';
                      if (!isValidChar) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <span id="time" className={`${remainingTime.minutes === 0 && 'text-red-800'}`}>
                  {remainingTime.minutes.toString().padStart(2, '0')}:
                  {remainingTime.seconds.toString().padStart(2, '0')}
                </span>
              </div>
              <div className="flex items-center gap-3 flex-col lg:flex-row lg:justify-evenly lg:flex-wrap">
                {!(remainingTime.minutes !== 0 || remainingTime.seconds !== 0) ? (
                  <button
                    disabled={remainingTime.minutes !== 0 || remainingTime.seconds !== 0}
                    onClick={handleResend}
                    className={`${
                      remainingTime.minutes === 0 && remainingTime.seconds === 0
                        ? 'hover:bg-hovergreen bg-customgreen'
                        : 'bg-green-200'
                    } lg:w-2/2 w-full mt-3 text-white font-bold py-2 px-4 rounded-2xl focus:outline-none focus:shadow-outline`}
                  >
                    {t('Resend')}
                  </button>
                ) : (
                  otp != '' && (
                    <button
                      disabled={remainingTime.minutes == 0 && remainingTime.seconds == 0}
                      onClick={handleSubmit}
                      type="submit"
                      className={`${
                        remainingTime.minutes === 0 && remainingTime.seconds === 0
                          ? 'bg-green-200'
                          : 'hover:bg-hovergreen bg-customgreen'
                      } lg:w-2/2 w-full text-white font-bold mt-3 py-2 px-4 rounded-2xl focus:outline-none focus:shadow-outline`}
                    >
                      {t('Submit OTP')}
                    </button>
                  )
                )}

                {/* <Link to={'/donorLogin'} className=" w-full ">
                  <button className="bg-customgreen hover:bg-hovergreen w-full mt-3 text-white font-bold py-2 px-4 rounded-2xl focus:outline-none focus:shadow-outline">
                    {t('Back')}
                  </button>
                </Link> */}
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function setStorage(response) {
  Object.keys(response).forEach((key) => {
    if (key === 'id') {
      saveToLocalStorage('upid', response[key]);
    } else {
      localStorage.setItem(key, response[key]);
    }
  });
}
